<template>
  <div>
    <!-- Header -->
    <div class="d-flex justify-space-between align-center mb-7">
      <div>
        <div style="font-size: 30px; font-weight: 800; color: #111827; letter-spacing: -0.5px; line-height: 1.2">
          Request Interns
        </div>
        <div class="mt-1" style="font-size: 14px; color: #6b7280">
          Find the perfect interns for your organization.
        </div>
      </div>
    </div>
    <v-row>
      <v-col cols="12" md="6" class="flex-items mt-2">
        <v-tabs v-model="activeTab" color="#00A63E" align-tabs="left">
          <v-tab
            v-for="tab in tabList"
            :key="tab.id"
            :value="tab.name"
            @click="changeTab(tab)"
            >{{ tab.name }}</v-tab
          >
        </v-tabs>
      </v-col>
      <v-col cols="12">
        <v-card flat class="rounded-xl table-card">
        <v-data-table
          :headers="headers"
          :items="tabledata"
          :search="search"
          :loading="loading"
          hover
          class="rounded-xl"
        >
          <template v-slot:[`item.pg`]="{ item }">
            <v-chip
              v-for="(i, idx) in getProgramNames(item.programs)"
              :key="idx"
              size="small"
              class="px-2 mx-2"
              >{{ i }}</v-chip
            >
          </template>
          <template v-slot:[`item.status`]="{ item }">
            <v-chip size="x-small" v-if="item.status == null"
              >For Approval</v-chip
            >
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <v-btn
              class="white--text"
              color="#00A63E"
              size="x-small"
              rounded
              @click="viewItem(item)"
            >
              view
            </v-btn>
          </template>
        </v-data-table>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog v-model="dialogConfirmDelete" max-width="500">
      <v-card>
        <v-card-title class="text-h6">Confirm Deletion</v-card-title>
        <v-card-text class="text-body-1">
          Are you sure you want to delete this item?
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn variant="text" @click="dialogConfirmDelete = false"
            >Cancel</v-btn
          >
          <v-btn color="error" class="white--text" @click="confirmDelete"
            >Confirm</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <ViewHTEInternRequestDialog :data="itemData" :action="action" />

    <fade-away-message-component
      displayType="default"
      v-model="fadeAwayMessage.show"
      :message="fadeAwayMessage.message"
      :header="fadeAwayMessage.header"
      :type="fadeAwayMessage.type"
    />
  </div>
</template>

<script>
import eventBus from "@/eventBus";
import ViewHTEInternRequestDialog from "../Dialogs/Views/ViewHTEInternRequestDialog.vue";

export default {
  components: {
    ViewHTEInternRequestDialog,
  },

  // props: {
  //   reloadTable: {
  //     type: Boolean,
  //     required: true,
  //   },
  // },
  data: () => ({
    search: "",
    activeTab: "For Approval",
    tab: 1,
    tabList: [
      {
        id: 1,
        name: "For Approval",
      },
      { id: 2, name: "Granted" },
      { id: 3, name: "Denied" },
    ],
    size: 200,
    headers: [
      { title: "HTE", value: "org.name", align: "start" },

      {
        title: "Number of Interns Requested",
        value: "num_interns",
        align: "center",
      },

      {
        title: "Actions",
        value: "actions",
        align: "center",
        sortable: false,
        width: 200,
      },
    ],
    data: [],
    skillsList: [],
    selectedSkills: [],
    programs_for: [],
    programSelected: [],
    perPageChoices: [
      { text: "5", value: 5 },
      { text: "10", value: 10 },
      { text: "20", value: 20 },
      { text: "50", value: 50 },
      { text: "100", value: 100 },
      { text: "250", value: 250 },
      { text: "500", value: 500 },
    ],
    expandTab1: false,
    expandTab2: false,
    programs: [],
    num_interns: null,
    showStudentMatching: false,
    itemData: null,
    viewData: null,
    loading: false,
    options: {},
    action: null,
    paginationData: {},
    formdata: [],
    tabledata: [],
    creds: null,
    dialogConfirmDelete: false,
    fadeAwayMessage: {
      show: false,
      type: "success",
      header: "Successfully Deleted!",
      message: "",
      top: 10,
    },
  }),
  mounted() {
    this.initialize();
    eventBus.on("closeCompanyInternRequestDialog", () => {
      this.initialize();
    });
  },
  beforeUnmount() {
    eventBus.off("closeCompanyInternRequestDialog");
  },
  methods: {
    pagination(data) {
      this.paginationData = data;
    },

    changeTab(tab) {
      this.activeTab = tab.name;
      this.tab = tab.id;
      this.initialize();
    },

    initialize() {
      this.axiosCall(
        "/organization/loadInternRequestByOrg/" + this.tab,
        "GET",
      ).then((res) => {
        if (res) {
          console.log("sds  ", res.data);
          this.tabledata = res.data;
        }
      });
    },

    getProgramNames(programs) {
      let arr = [];
      for (let i = 0; i < programs.length; i++) {
        for (let j = 0; j < this.programs.length; j++) {
          if (programs[i] == this.programs[j].id) {
            arr.push(this.programs[j].abbr);
          }
        }
      }
      return arr;
    },

    addInternRequest() {
      this.itemData = { id: null };
      this.action = "Add";
    },

    loadSkills() {
      let progs = JSON.stringify(this.programSelected);
      console.log("PROGS", progs);
      if (this.programSelected.length > 0) {
        this.axiosCall(
          "/skill-assessement/getSkillCategoryByProgram/" + progs,
          "GET",
        ).then((res) => {
          if (res.data) {
            console.log(res.data);
            this.skillsList = res.data;
          }
        });
      }
    },

    async save() {
      let validate = await this.$refs.InternRequestForm.validate();
      if (validate.valid) {
        if (this.programSelected.length == 0) {
          this.fadeAwayMessage.show = true;
          this.fadeAwayMessage.type = "error";
          this.fadeAwayMessage.header = "System Message";
          this.fadeAwayMessage.message = "Please select program.";
        } else {
          let data = {
            programSelected: JSON.stringify(this.programSelected),
            num_interns: this.num_interns,
            skills: JSON.stringify(this.selectedSkills),
          };

          this.axiosCall("/organization/add-intern-request", "POST", data).then(
            (res) => {
              if (res.data.status == 201) {
                this.fadeAwayMessage.show = true;
                this.fadeAwayMessage.type = "success";
                this.fadeAwayMessage.header = "System Message";
                this.fadeAwayMessage.message = res.data.msg;
                this.showStudentMatching = true;
              } else if (res.data.status == 400) {
                this.fadeAwayMessage.show = true;
                this.fadeAwayMessage.type = "error";
                this.fadeAwayMessage.header = "System Message";
                this.fadeAwayMessage.message = res.data.msg;
              }
            },
          );
        }
      }
    },

    viewMatching(item) {
      console.log(item);
      this.expandTab1 = true;
      this.showStudentMatching = true;

      this.axiosCall("/student/find-intern/byRequest/" + item.id, "GET").then(
        (res) => {
          console.log(res.data);
        },
      );
    },

    viewItem(item) {
      this.itemData = item;
      this.action = "View";
    },

    manageItem(item) {
      this.creds = item;
    },
    confirmDelete() {
      this.axiosCall("/request-type/" + this.deleteData.id, "DELETE").then(
        () => {
          this.fadeAwayMessage.show = true;
          this.itemData = null;
          this.initialize();
        },
      );
    },
  },
};
</script>

<style scoped>
.table-card {
  border: 1px solid #d1d5db !important;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.06) !important;
}
</style>
